<template>
  <div id="app">
    <AppHeader />
    <router-view/>
  </div>
</template>

<script>
import 'keen-ui/dist/keen-ui.css';
import AppHeader from '@/components/AppHeader';

export default {
  name: 'App',
  hagridActions: ['Login/checkLogin'],
  components: {
    AppHeader,
  },
};
</script>

<style>
*,
*::before,
*::after {
    box-sizing: border-box;
}

html {
    font-size: 100%;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/App.vue